export const DASHBOARD_TOOLBAR_GHOST_BUTTON_STYLE = {
  color: "#4f5d6b",
  borderColor: "#d7dde5",
  backgroundColor: "#fff",
  boxShadow: "none",
};

export const DASHBOARD_TOOLBAR_SOFT_ACTION_BUTTON_STYLE = {
  color: "#1f3b57",
  borderColor: "transparent",
  backgroundColor: "#edf4fb",
  boxShadow: "none",
};

export const DASHBOARD_TOOLBAR_DANGER_BUTTON_STYLE = {
  color: "#d92550",
  borderColor: "#f3b8c4",
  backgroundColor: "#fff5f7",
  boxShadow: "none",
};

export const DASHBOARD_TOOLBAR_CONTROL_HEIGHT_STYLE = {
  height: 34,
  minHeight: 34,
  display: "inline-flex",
  alignItems: "center",
};

export const DASHBOARD_TOOLBAR_SELECT_STYLE = {
  height: 34,
  minHeight: 34,
  paddingTop: 0,
  paddingBottom: 0,
};

export const hasAnyActiveFilter = (filters = {}, keys = []) =>
  keys.some((key) => {
    const value = filters[key];
    return value !== undefined && value !== null && String(value).trim() !== "";
  });
